const getRangeValue = (value) => {
  if (!value) return null;
  return Array.isArray(value[0]) ? value[0] : value;
};

export const buildLeadExportPayload = (filters = {}, email) => {
  const payload = {};
  const createdDateRange = getRangeValue(filters.createdDtm);
  const assignedDateRange = getRangeValue(filters.assignedDate);

  if (email) {
    payload.email = email;
  }
  if (filters.title?.[0]) {
    payload.title_contain = filters.title[0];
  }
  if (filters.status?.length) {
    payload.status = filters.status.join(",");
  }
  if (filters.project?.length) {
    payload.project = filters.project.join(",");
  }
  if (filters.developer?.length) {
    payload.developer = filters.developer.join(",");
  }
  if (filters.city?.length) {
    payload.city = filters.city.join(",");
  }
  if (filters.manager?.length) {
    payload.manager = filters.manager.join(",");
  }
  if (filters.createdBy?.length) {
    payload.createdBy = filters.createdBy.join(",");
  }
  if (filters.assignedTo?.length) {
    payload.assignedTo = filters.assignedTo.join(",");
  }
  if (filters.lead_source?.length) {
    payload.lead_source = filters.lead_source.join(",");
  }
  if (createdDateRange?.[0] && createdDateRange?.[1]) {
    payload.created_date_start = createdDateRange[0];
    payload.created_date_end = createdDateRange[1];
  }
  if (assignedDateRange?.[0] && assignedDateRange?.[1]) {
    payload.assigned_date_start = assignedDateRange[0];
    payload.assigned_date_end = assignedDateRange[1];
  }
  if (filters.follow_up?.[0] && filters.follow_up?.[1]) {
    payload.follow_up_start_date = filters.follow_up[0];
    payload.follow_up_end_date = filters.follow_up[1];
  }

  return payload;
};
